<template>
  <v-card v-if="model.id" class="elevation-2" color="grey lighten-3">
    <v-card-title class="text-h5">
      <h3 class="font-weight-bold text--primary text-uppercase">{{model.NombreCompleto}} - ({{model.telefono}})</h3>
    </v-card-title>
    <v-card-text>
      <v-row dense>
        <v-col cols="12">
          <DataTableMain
            :datatable="table"
            :on-success="successAction"
            :itemsAction="tableAction" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import { Permission } from '@/mixins/permissionMain'
export default {
  props: ['model', 'onSuccess'],
  mixins: [Permission],
  data: () => ({
    table: {
      header: {
        options: [],
        titles: [
          { text: '', value: 'Actions', class: 'black--text' },
          { text: 'Tipo de Credito', value: 'tipoCredito', class: 'black--text' },
          { text: 'Plazo', value: 'plazo', class: 'black--text' },
          { text: 'Valor Vivienda', value: 'FieldDinamicData', class: 'black--text', action: 'FormatNumberMoney', field: 'precioVivienda' },
          { text: 'Monto de Credito', value: 'FieldDinamicData', class: 'black--text', action: 'FormatNumberMoney', field: 'MontoCredito' },
          { text: 'Enganche', value: 'FieldDinamicData', class: 'black--text', action: 'FormatNumberMoney', field: 'EngancheCliente' },
          { text: 'Enganche Adicional', value: 'FieldDinamicData', class: 'black--text', action: 'FormatNumberMoney', field: 'engancheAdicional' }

        ],
        losading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Descargar PDF', icon: 'mdi-file-pdf', color: 'amber darken-2', action: 'toDownloadView', code: 'pre-calificacion.tipo-credito.pdf' }
        ]
      },
      footer: {
        paging: true
      }
    },
    credits: []
  }),
  components: {
    DataTableMain
  },
  mounted () {
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapMutations([]),
    successAction (item) {
      this[item.action](item)
    },
    tableAction (item) {
      this.onSuccess(item)
    }
  },
  computed: {
    ...mapGetters([])
  },
  watch: {
    model (val) {
      if (val) {
        this.credits = val.customer_credits
        this.table.body.data = this.credits
      }
    }
  }
}
</script>

<style>
</style>
